module.exports = __webpack_public_path__ + "static/media/twitter.954af597.png";